module.exports = __webpack_public_path__ + "img/basicInfo.ec3a35ed.svg";